import { Component, Host, h, Element, Prop, Listen } from '@stencil/core';
import debounce from 'debounce';
import { versionComponent } from '../../global/inject-dependencies';

@Component({
  tag: 'ui-header',
  styleUrl: 'ui-header.scss',
  shadow: true,
})
export class UiHeader {
  @Element() el: HTMLElement;

  @Prop({ reflect: true }) fixed = false;

  private refHeaderElement?: HTMLElement;

  private resizeObserver: ResizeObserver;

  componentDidLoad() {
    this.setBodySpacing();
    this.addResizeObserver();
  }

  /**
   * Listening for ui-sticky component event, as ui-header is fixed by style
   * ui-sticky has to consider it while calculator its position.
   */
  @Listen('uiStickyComponentIsReady', { target: 'window' })
  onStickyComponentReady(e) {
    const uiStickyElement = e.target as HTMLUiStickyElement;
    uiStickyElement.addElementToCalculation([this.refHeaderElement]);
  }

  private addResizeObserver() {
    this.resizeObserver = new ResizeObserver(
      debounce(() => {
        this.setBodySpacing();
      }, 100)
    );

    this.resizeObserver.observe(this.refHeaderElement);
  }

  /**
   * Sets spacing on the body based on the height of the header
   * to ensure that content is not covered by the header
   */
  private setBodySpacing() {
    document.body.style.paddingTop = `${this.refHeaderElement.clientHeight}px`;
  }

  render() {
    return (
      <Host>
        <header
          ref={(el) => {
            this.refHeaderElement = el;
          }}
          class="header"
          role="banner"
        >
          <div class="content">
            <slot></slot>
          </div>
        </header>
      </Host>
    );
  }
}

versionComponent(UiHeader);
